import React from 'react';

import './AuthenticationSpinner.scss'

import Loader from '../../components/Loader/Loader';

const AuthenticationSpinner = () =>
  <div className="authentication-spinner-loading-screen">
    <div className="authentication-spinner-loader-container">
      <Loader isVisible />
    </div>
  </div>;

export default AuthenticationSpinner;
